module.exports = __webpack_public_path__ + "static/media/card1.977f804d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/card1.png
// module id = 22
// module chunks = 0